import React, {useEffect} from 'react'
import {
    questionnaireError, questionnaireLabel, questionnaireLabelDescription,
} from 'components/Embed/styles/questionnaire'

import ReactMarkdown from 'react-markdown'

import {
    inputWrapper,
} from './styles'

import {markdownProps} from 'components/Embed/helpers/markdown'
import {styled} from 'stitches/config'
import {
    styledInput,
} from 'components/Form/styles/FormView'

const StyledInputWrapper = styled('div', inputWrapper)
const StyledInput = styled('input', {
    ...styledInput,
    boxSizing: 'border-box',
    padding: '$input',
    width: '100%',
})
const StyledLabel = styled('label', questionnaireLabel)
const StyledLabelDescription = styled('span', questionnaireLabelDescription)
const StyledError = styled('div', questionnaireError)

export interface QuestionnaireInputProps {
    id: string
    name: string
    readableName?: string
    groupName?: string
    label?: string
    labelDescription?: string
    placeholder?: string
    padding: string
    value: string
    forceValidation?: boolean
    invalid?: boolean
    invalidText?: string
    showCorrectState?: boolean
    required?: boolean
    onChange: (params: {name: string, value: string, readableName?: string, groupName?: string}) => void
    setInvalidFields: (name: string, invalid: boolean) => void
}

export const QuestionnaireInput = (props: QuestionnaireInputProps) => {
    const {
        label, placeholder, forceValidation, id, value, onChange, setInvalidFields, labelDescription,
        name, readableName, groupName, invalid, invalidText, showCorrectState, required, padding, ...other
    } = props

    const [touched, setTouched] = React.useState(false)

    // eslint-disable-next-line no-extra-parens
    const isInvalid = (invalid && (touched || forceValidation || value)) || (!invalid && required && value === '' && (touched || forceValidation))
    const isCorrect = showCorrectState && value ? !isInvalid : false

    useEffect(() => {
        if (forceValidation && required) {
            setInvalidFields(name, !!isInvalid)
        }
    }, [forceValidation, isInvalid, required])

    return (
        <StyledInputWrapper>
            <StyledLabel htmlFor={id}>{label} <StyledLabelDescription>{labelDescription}</StyledLabelDescription></StyledLabel>
            <StyledInput
                aria-describedby={isInvalid ? `${id}-error` : undefined}
                aria-invalid={isInvalid ? 'true' : 'false'}
                correct={isCorrect}
                css={{padding}}
                id={id}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setTouched(true)
                    onChange({
                        groupName,
                        name,
                        readableName,
                        value: event.target.value,
                    })
                }}
                placeholder={placeholder}
                required={required}
                value={value}
                {...other}
            />
            {isInvalid ?
                <StyledError id={`${id}-error`} role='alert'>
                    <ReactMarkdown {...markdownProps}>
                        {invalidText || ''}
                    </ReactMarkdown>
                </StyledError>
                : null}
        </StyledInputWrapper>
    )
}

QuestionnaireInput.defaultProps = {
    forceValidation: false,
    groupName: '',
    invalid: false,
    invalidText: '',
    label: '',
    labelDescription: '',
    placeholder: '',
    readableName: '',
    required: false,
    showCorrectState: false,
}
